var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from "prop-types";
import classnames from "classnames";
export var Spin = function (props) {
    var _a, _b;
    var _c = props.size, size = _c === void 0 ? "md" : _c, _d = props.className, className = _d === void 0 ? "" : _d, style = props.style, indicator = props.indicator, tip = props.tip, children = props.children, spinning = props.spinning;
    var classNames = classnames((_a = {},
        _a["mex-spin__wrapper"] = true,
        _a[className] = className,
        _a));
    var spinner = (_jsxs("div", __assign({ className: "mex-spin__container" }, { children: [indicator ? indicator : _jsx("div", { className: "mex-spin__spinner mex-spin__spinner--".concat(size), style: style }), tip && _jsx("div", __assign({ className: "mex-spin__tip" }, { children: tip }))] })));
    var childClassNames = classnames((_b = {},
        _b["mex-spin__child"] = true,
        _b["mex-spin__blur"] = spinning,
        _b));
    if (children) {
        return (_jsx("div", __assign({ className: classNames }, { children: _jsxs("div", __assign({ className: childClassNames }, { children: [children, spinning && spinner] })) })));
    }
    return _jsx("div", __assign({ className: classNames }, { children: spinner }));
};
Spin.propTypes = {
    size: PropTypes.oneOf(["sm", "md", "lg"]),
    className: PropTypes.string,
    style: PropTypes.object,
    indicator: PropTypes.node,
    tip: PropTypes.string,
    spinning: PropTypes.bool,
    children: PropTypes.node,
};
Spin.defaultProps = {
    size: "md",
};
export default Spin;
